import { useState } from 'react'
import { Button, Dialog, HStack, Portal, Text } from '@chakra-ui/react'
import { LuMonitor } from 'react-icons/lu'
import { useTranslation } from '../i18n'

// Header button that enables/disables the per-video rotation & force-vertical
// controls. Turning them ON requires confirming a modal that explains the
// controls affect the live feed shown on screens by the desktop playback app.
// Turning them OFF is immediate.
export function DisplayControlsToggle({ enabled, onChange, size = 'sm' }) {
  const { t } = useTranslation()
  const [confirmOpen, setConfirmOpen] = useState(false)

  const handleClick = () => {
    if (enabled) {
      onChange(false)
    } else {
      setConfirmOpen(true)
    }
  }

  const handleConfirm = () => {
    onChange(true)
    setConfirmOpen(false)
  }

  return (
    <>
      <Button
        size={size}
        variant={enabled ? 'solid' : 'outline'}
        onClick={handleClick}
      >
        <LuMonitor /> {enabled ? t('displayControls.enabled') : t('displayControls.enable')}
      </Button>

      <Dialog.Root open={confirmOpen} onOpenChange={(e) => setConfirmOpen(e.open)}>
        <Portal>
          <Dialog.Backdrop />
          <Dialog.Positioner>
            <Dialog.Content>
              <Dialog.Header>
                <Dialog.Title>{t('displayControls.confirmTitle')}</Dialog.Title>
              </Dialog.Header>
              <Dialog.Body>
                <Text>{t('displayControls.confirmBody')}</Text>
              </Dialog.Body>
              <Dialog.Footer>
                <HStack gap={3}>
                  <Button variant="outline" onClick={() => setConfirmOpen(false)}>
                    {t('common.cancel')}
                  </Button>
                  <Button colorPalette="brand" onClick={handleConfirm}>
                    {t('displayControls.confirmButton')}
                  </Button>
                </HStack>
              </Dialog.Footer>
            </Dialog.Content>
          </Dialog.Positioner>
        </Portal>
      </Dialog.Root>
    </>
  )
}
